<template>
  <v-app>
    <v-main>
      <v-container fluid pa-0>
        <Header />

        <v-parallax :height="parallax_height" src="./assets/images/apples.jpg">
          <image-heading
            heading="life is too short to not eat good food."
          ></image-heading
        ></v-parallax>

        <why-foodtag id="why_foodtag" />
        <marked-quality id="quality_mark" />

        <v-parallax :height="parallax_height" src="./assets/images/grapes.jpg">
          <image-heading
            heading="Shift your lifestyle. Change your choice of food."
          ></image-heading
        ></v-parallax>

        <our-values id="our_values" />

        <v-parallax :height="parallax_height" src="./assets/images/image-7.jpg">
          <image-heading
            heading="Wellbeing with one simple act."
          ></image-heading
        ></v-parallax>

        <contact-us id="contact_us" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import ContactUs from './components/ContactUs.vue';
import Header from './components/header.vue';
import ImageHeading from './components/ImageHeading.vue';
import MarkedQuality from './components/MarkedQuality.vue';
import OurValues from './components/OurValues.vue';
import WhyFoodtag from './components/WhyFoodtag.vue';
export default {
  name: 'App',
  components: {
    MarkedQuality,
    ImageHeading,
    WhyFoodtag,
    OurValues,
    ContactUs,
    Header,
  },

  data: () => ({
    scrollOptions: {
      duration: 400,
      offset: 0,
      easing: 'easeInOutCubic',
    },
    parallax_height: 300,
  }),
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@400;500&family=Darker+Grotesque:wght@400;500;600;700&family=Dosis:wght@300;400;500&family=The+Girl+Next+Door&display=swap');
html {
  overflow-y: auto;
  background-color: #f4f4f4;
}

.overlay {
  background: linear-gradient(
    90deg,
    rgb(227, 255, 162) 0%,
    rgba(227, 255, 162) 33%,
    rgba(194, 255, 80, 0) 100%
  );
}

.logo-background {
  background-color: white;
  height: 100vh;
}

.logo {
  width: 80%;
  /* border-radius: 15px; */
}

.slogan {
  font-family: 'Comfortaa', sans-serif;
  font-weight: 500;
  font-size: 30px;
}

.app-header {
  background-image: linear-gradient(
      90deg,
      rgba(244, 244, 244, 1) 0%,
      rgba(255, 255, 244, 1) 33%,
      rgba(244, 244, 244, 0) 100%
    ),
    url('./assets/images/image-8.jpg');
  height: 80vh;
  background-size: cover;
  color: white;
}

.route-name {
  font-family: 'Comfortaa', sans-serif;
  font-size: 18px;
  /* letter-spacing: 2px; */
  /* word-spacing: 2px; */
  color: #000000;
  font-weight: 600;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
  margin-right: 20px;
  text-transform: lowercase;
}

.heading {
  font-family: 'The Girl Next Door', sans-serif;
  font-weight: 700;
  font-size: 60px;
  padding: 10px;
  text-transform: lowercase;
}

.sub-heading {
  font-family: 'Comfortaa', sans-serif;
  font-weight: 600;
  font-size: 30px;
  margin: 10px 0;
}

.section-heading {
  font-family: 'Comfortaa', sans-serif;
  font-weight: 700;
  font-size: 40px;
  margin: 10px 0;
  text-transform: lowercase;
  line-height: 40px;
}

.body {
  font-family: 'Dosis', sans-serif;
  font-weight: 400;
  font-size: 26px;
  /* line-height: 26px; */
}

.section {
  scroll-behavior: smooth; /* <----- THE SECRET ---- */
}

.bord {
  border: 1px solid fuchsia;
}

/* ::-webkit-scrollbar-track {
  width: 6px;
  background-color: #ededed;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  border-radius: 9999px;
  background-color: rgba(65, 65, 65, 0.4);
} */
</style>
